/** Converts plain text to a minimal Tiptap doc: one paragraph per non-empty line. */
export function textToTiptap(text: string): Record<string, unknown> {
  const paragraphs = text
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean)
    .map((line) => ({ type: 'paragraph', content: [{ type: 'text', text: line }] }));
  return { type: 'doc', content: paragraphs.length ? paragraphs : [{ type: 'paragraph' }] };
}
